<template>
  <div id="loginBox">
    <div class="loginFormContainer">
      <div class="leftLogoBox">
        <img src="../../assets/image/company_logo.png" alt />
      </div>
      <div class="rightBox">
        <h3>登录账号</h3>
        <p>Process Management</p>
        <!--!! 登录 -->
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="isLogin">
          <!-- 账号登录 -->
          <el-tab-pane label="账号登录" name="first">
            <div class="loginInput">
              <img src="../../assets/image/icon_sjh@2x.png" alt />
              <el-input placeholder="电话号码" v-model="loginForm.userName"></el-input>
            </div>
            <div class="loginInput">
              <img src="../../assets/image/icon_mm@2x.png" alt />
              <el-input placeholder="账号密码" type="password" v-model="loginForm.password"></el-input>
            </div>
            <div class="noUserName">
              <span>没有账号？去</span>
              <span class="clickSpan" @click="goRegister">注册</span>
            </div>
            <div class="btnRow">
              <el-button type="primary" @click="handleLoginSubmit">立即登录</el-button>
            </div>
            <div class="agree">
              登录即表示阅读并同意
              <a target="view_window" href="https://control.sxpz.vip/agreement.html">《邦泰云安全用户协议》</a target="view_window">
            </div>
          </el-tab-pane>
          <!-- 短信登录 -->
          <el-tab-pane label="短信登录" name="second">
            <div class="loginInput">
              <img src="../../assets/image/icon_sjh@2x.png" alt />
              <el-input placeholder="电话号码" v-model="loginForm.userName"></el-input>
            </div>
            <div class="loginInput">
              <img src="../../assets/image/icon_yzm@2x.png" alt />
              <el-input placeholder="验证码" v-model="loginForm.verificationCode"></el-input>
              <el-button
                class="getBtn"
                @click="getVer1"
                type="primary"
                :disabled="!BtnStatus"
              >{{BtnStatus?'获取验证码':`${countDownTime}秒后获取`}}</el-button>
            </div>
            <div class="noUserName">
              <span>没有账号？去</span>
              <span class="clickSpan" @click="goRegister">注册</span>
            </div>
            <div class="btnRow">
              <el-button type="primary" @click="handleCodeSubmit">立即登录</el-button>
            </div>
            <div class="agree">
              登录即表示阅读并同意
              <a href="https://control.sxpz.vip/agreement.html">《邦泰云安全用户协议》</a>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!--!! 注册 -->
        <div class="registerBox" v-if="!isLogin">
          <div class="loginInput">
            <img src="../../assets/image/icon_sjh@2x.png" alt />
            <el-input placeholder="请输入手机号" v-model="registerForm.phoneNumber"></el-input>
          </div>
          <div class="loginInput">
            <img src="../../assets/image/icon_mm@2x.png" alt />
            <el-input placeholder="请输入6-32位密码" type="password" v-model="registerForm.password1"></el-input>
          </div>
          <div class="loginInput">
            <img src="../../assets/image/icon_mm@2x.png" alt />
            <el-input placeholder="请输入确认密码" type="password" v-model="registerForm.password2"></el-input>
          </div>
          <div class="loginInput lastInput">
            <img src="../../assets/image/icon_yzm@2x.png" alt />
            <el-input placeholder="验证码" type="password" v-model="registerForm.verificationCode"></el-input>
            <!-- <el-button class="getBtn" @click="getVer" type="primary">获取验证码</el-button> -->
            <el-button
              class="getBtn"
              @click="getVer"
              type="primary"
              :disabled="!BtnStatus"
            >{{BtnStatus?'获取验证码':`${countDownTime}秒后获取`}}</el-button>
          </div>
          <div class="noUserName">
            <span>已有账号？去</span>
            <span class="clickSpan" @click="goRegister">登录</span>
          </div>
          <div class="btnRow">
            <el-button @click="handleRegisterSubmit" type="primary">注册</el-button>
          </div>
          <div class="agree">登录即表示阅读并同意《邦泰云安全用户协议》</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 验证码禁用
      BtnStatus: true,
      countDownTime: 60,
      activeName: 'first',
      // 登录表单
      loginForm: {
        userName: '',
        password: '',
        verificationCode: '',
      },
      // 注册表单
      registerForm: {
        // 手机
        phoneNumber: '',
        // 密码
        password1: '',
        // 确认密码
        password2: '',
        // 验证码
        verificationCode: '',
      },
      isLogin: true,
    }
  },
  methods: {
    // *登录(账号密码)
    async handleLoginSubmit() {
      if (this.loginForm.userName.trim().length == 0) {
        return this.$message.error('请输入电话号码')
      }
      // 手机号正则校验
      const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/
      let isPhoneNum = reg.test(this.loginForm.userName)
      if (!isPhoneNum) {
        return this.$message.error('请输正确入手机号')
      }
      if (!this.loginForm.password) return this.$message.error('请输入密码')

      let param = new URLSearchParams()
      param.append('username', this.loginForm.userName)
      param.append('password', this.loginForm.password)
      param.append('model', 'pc')
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Public/login_by_password',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)

      // 用户id
      window.localStorage.setItem(
        'btlh_process_member_id',
        res.datas.info.member_id
      )
      // 头像
      window.localStorage.setItem(
        'btlh_process_avatarUrl',
        res.datas.info.avatar
      )
      // 用户邮箱
      window.localStorage.setItem('btlh_process_mail', res.datas.info.mail)
      // 用户昵称
      window.localStorage.setItem(
        'btlh_process_nickname',
        res.datas.info.nickname
      )
      // token
      window.localStorage.setItem('btlh_process_token', res.datas.info.token)
      this.$router.push('/join')
    },
    // *登录(验证码)
    async handleCodeSubmit() {
      if (this.loginForm.userName.trim().length == 0) {
        return this.$message.error('请输入电话号码')
      }
      // 手机号正则校验
      const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/
      let isPhoneNum = reg.test(this.loginForm.userName)
      if (!isPhoneNum) {
        return this.$message.error('请输正确入手机号')
      }
      if (!this.loginForm.verificationCode)
        return this.$message.error('请输入密码')

      let param = new URLSearchParams()
      param.append('username', this.loginForm.userName)
      param.append('code', this.loginForm.verificationCode)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Public/login_by_code',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)

      // 用户id
      window.localStorage.setItem(
        'btlh_process_member_id',
        res.datas.info.member_id
      )
      // 头像
      window.localStorage.setItem(
        'btlh_process_avatarUrl',
        res.datas.info.avatar
      )

      // 用户邮箱
      window.localStorage.setItem('btlh_process_mail', res.datas.info.mail)
      // 用户昵称
      window.localStorage.setItem(
        'btlh_process_nickname',
        res.datas.info.nickname
      )
      // token
      window.localStorage.setItem('btlh_process_token', res.datas.info.token)
      this.$router.push('/join')
    },
    // *登录登录-发送验证码
    async getVer1() {
      // 手机号是否为空
      if (this.loginForm.userName.trim().length == 0) {
        return this.$message.error('请输入手机号')
      }
      // 手机号正则校验
      const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/
      let isPhoneNum = reg.test(this.loginForm.userName)
      if (!isPhoneNum) {
        return this.$message.error('请输正确入手机号')
      }
      this.GetCode()
      let param = new URLSearchParams()
      param.append('username', this.loginForm.userName)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Public/send_message',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
    },

    // *注册-点击注册按钮
    async handleRegisterSubmit() {
      if (this.registerForm.phoneNumber.trim().length == 0) {
        return this.$message.error('请输入电话号码')
      }
      if (!this.registerForm.password1) return this.$message.error('请输入密码')
      if (!this.registerForm.password2)
        return this.$message.error('请输入确认密码')
      if (!this.registerForm.verificationCode)
        return this.$message.error('请输入验证码')
      if (this.registerForm.password1 != this.registerForm.password2)
        return this.$message.error('两次输入的密码不一致')
      let param = new URLSearchParams()
      param.append('username', this.registerForm.phoneNumber)
      param.append('password', this.registerForm.password1)
      param.append('repassword', this.registerForm.password2)
      param.append('code', this.registerForm.verificationCode)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Public/reg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.isLogin = true
    },
    // *注册-发送验证码
    async getVer() {
      // 手机号是否为空
      if (this.registerForm.phoneNumber.trim().length == 0) {
        return this.$message.error('请输入手机号')
      }
      // 手机号正则校验
      const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/
      let isPhoneNum = reg.test(this.registerForm.phoneNumber)
      if (!isPhoneNum) {
        return this.$message.error('请输正确入手机号')
      }
      this.GetCode()
      let param = new URLSearchParams()
      param.append('username', this.registerForm.phoneNumber)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Public/send_message',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
    },

    // 验证码倒计时
    GetCode() {
      let endMsRes = new Date().getTime() + 60000
      localStorage.setItem('myEndTime', JSON.stringify(endMsRes))
      this.codeCountDown(endMsRes)
    },
    codeCountDown(endMsRes) {
      this.BtnStatus = false
      this.countDownTime = Math.ceil((endMsRes - new Date().getTime()) / 1000)
      let time = setTimeout(() => {
        this.countDownTime--
        if (this.countDownTime < 1) {
          this.BtnStatus = true
          this.countDownTime = 60
          localStorage.removeItem('myEndTime')
          clearTimeout(time)
        } else {
          this.codeCountDown(endMsRes)
        }
      }, 1000)
    },
    // 注册登录切换
    goRegister() {
      this.isLogin = !this.isLogin
      // localStorage.setItem('myLoginIsLoginStatus',)
    },
    // 登录方式切换
    handleClick(tab, event) {
      localStorage.setItem('myLoginTabStatus', tab.name)
    },
  },
  created() {
    let myEndTime = localStorage.getItem('myEndTime')
    if (localStorage.getItem('myLoginTabStatus')) {
      this.activeName = localStorage.getItem('myLoginTabStatus')
    }
    myEndTime && this.codeCountDown(myEndTime)
    if (
      localStorage.getItem('btlh_process_token') &&
      localStorage.getItem('btlh_process_member_id')
    ) {
      this.$router.push('/')
    }
  },
}
</script>
<style lang="less" scoped>
#loginBox {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('../../assets/image/bg1.png') no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  -webkit-display: flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  .loginFormContainer {
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);

    // margin-top: 15vh;
    width: 62.5%;
    // height: 70.5%;
    background: url('../../assets/image/bg2.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    .leftLogoBox {
      width: 50%;
      img {
        width: 55%;
        margin-top: 4%;
        margin-left: 4%;
      }
    }
    .rightBox {
      width: 50%;
      padding-right: 7%;
      padding-left: 20%;
      h3 {
        margin-top: 22%;
        // margin-top: 95px;
        width: 100%;
        color: #128bf1;
        font-size: 36px;
        font-family: 'MicrosoftYaHei';
        text-align: center;
      }
      p {
        color: #cccccc;
        text-align: center;
        font-size: 20px;
      }
      /deep/.el-tabs {
        margin-top: 10%;
      }
      // 登录输入框
      .loginInput {
        margin-top: 7%;
        position: relative;
        height: 50px;
        display: flex;
        align-items: center;
        img {
          position: absolute;
          left: 0px;
          // top: 20%;
          z-index: 2;
          width: 15px;
          height: 23px;
        }
        // 获取验证码按钮
        .getBtn {
          position: absolute;
          right: 0;
          width: 100px;
          height: 30px;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          border-color: #40a0f2;
          background-color: #40a0f2;
        }
      }
      // 没有账号
      .noUserName {
        font-size: 16px;
        color: #c0c8cd;
        text-align: right;
        margin-top: 4%;
        .clickSpan {
          color: #128bf1;
          cursor: pointer;
        }
      }
      // 登录按钮
      .btnRow {
        margin-top: 10%;
        width: 100%;
        /deep/.el-button {
          width: 100%;
          height: 60px;
          border-radius: 30px;
          border: none;
          font-size: 20px;
          background: linear-gradient(to top, #037ce3, #2eb3ff);
        }
      }
      .agree {
        font-size: 16px;
        color: #c0c8cd;
        text-align: center;
        margin-top: 8%;
        margin-bottom: 15%;
      }
      // 注册
      .registerBox {
        .loginInput {
          margin-top: 3.4%;
        }
        .lastInput {
          margin-bottom: -0.1%;
        }
      }
    }
  }
}
// 修改input
/deep/.el-input__inner {
  background-color: rgba(255, 255, 255, 0);
  outline: none;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  padding-left: 30px;
  font-size: 18px;
  height: 50px;
}

// 修改tabs
/deep/.el-tabs {
  width: 100%;
  .el-tabs__header {
    width: 100%;
    .el-tabs__nav-wrap {
      width: 100%;
      .el-tabs__nav-scroll {
        width: 100%;
        .el-tabs__nav {
          width: 100%;
        }
      }
    }
  }
}
/deep/.el-tabs__item {
  text-align: center;
  font-size: 22px;
  color: #999999;
  font-weight: 400;
  width: 50% !important;
}
/deep/.el-tabs__item.is-active {
  color: #1289ee !important;
}
/deep/.el-tabs__item:hover {
  color: #1289ee !important;
}
/deep/.el-tabs__nav-wrap::after {
  color: #f1f9ff;
}

/deep/.el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b4b4b4;
  font-size: 18px;
}

/deep/.el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #b4b4b4;
  font-size: 18px;
}

/deep/.el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #b4b4b4;
  font-size: 18px;
}
</style>